module.exports = __webpack_public_path__ + "img/Meetings space.5ab6a71d.jpeg";